import * as yup from "yup";

export const buildSchema = (isRootProfile: boolean) =>
  yup.object().shape({
    jointType: yup.string().required("Joint ownership type is required"),
    name: yup.string().required("Name is required"),
    ownershipPercentage: isRootProfile
      ? yup.number().nullable()
      : yup
          .number()
          .nullable()
          .required("Ownership percentage is required")
          .min(1, "Ownership percentage must be at least 1")
          .max(100, "Ownership percentage cannot exceed 100"),
    domicileCountry: yup.string(),
  });
